import Script from 'next/script';
import React from 'react';

export function SetupGoogleAnalyticsTagScript() {
  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=G-5RS64RJTJS`}
        strategy="afterInteractive"
      />
      <Script
        id="google-ads-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-5RS64RJTJS');
          `,
        }}
      />
    </>
  );
}
